import { Table as AntdTable, TableProps } from 'antd'

export const Table = (props: TableProps<any>) => <AntdTable {...props} />
